var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 2003.34,
    x2: 2000,
    y2: 3.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4860ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e4df6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 3.34,
    width: 2000,
    height: 2000
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1000,1189.65c216.1-43,359.71-225.18,359.71-448.2,0-198.67-161-359.72-359.71-359.72s-359.71,161-359.71,359.72C640.29,964.47,783.9,1146.66,1000,1189.65Zm449.64-448.2c0,255.12-160.88,470.05-406.47,530.66l21.94,43.8a22.52,22.52,0,1,1-40.29,20.14l-.72-1.52a218,218,0,0,0,3.33,26.07c4.85,24.29,14.48,43.89,37.68,90.2,25.9,52,21.13,103.42,6.83,146.5-14.12,42.17-38,78-52.88,100.27l-.35.63a22.5,22.5,0,0,1-37.42-25h0c15.11-22.67,36-54,47.94-90.2,12-35.61,14.66-74.1-4.41-112l-1.17-2.52c-21.58-43.17-34.17-68.17-40.29-99.1a285.16,285.16,0,0,1-4.67-40.47l-3.6,7.19a22.48,22.48,0,1,1-40.35-19.83l.15-.31,21.94-43.8C711.24,1211.5,550.36,996.57,550.36,741.45c0-248.33,201.31-449.65,449.64-449.65S1449.64,493.12,1449.64,741.45ZM825.72,696.93A180.1,180.1,0,0,1,955.49,567.17c24.1-6.12,44.51-25.72,44.51-50.54s-20.32-45.33-44.78-41.28A270,270,0,0,0,734,696.66c-4.14,24.46,16.37,44.79,41.19,44.79S819.6,721,825.72,696.93Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFull);
export default __webpack_public_path__ + "static/media/icon_full.e0757742173787eead840a20a04b7137.svg";
export { ForwardRef as ReactComponent };